const symbolize = (combo) => {
  var map = {
    command: "\u2318", // ⌘
    shift: "\u21E7", // ⇧
    left: "\u2190", // ←
    right: "\u2192", // →
    up: "\u2191", // ↑
    down: "\u2193", // ↓
    return: "\u23CE", // ⏎
    backspace: "\u232B", // ⌫
    option: "\u2325", // ⌥
  }
  combo = combo.split("+")

  for (var i = 0; i < combo.length; i++) {
    // try to resolve command / ctrl based on OS:
    if (combo[i] === "mod" || combo[i] === "meta") {
      if (window.navigator && window.navigator.platform.indexOf("Mac") >= 0) {
        combo[i] = "command"
      } else {
        combo[i] = "ctrl"
      }
    }

    if (combo[i] === "option") {
      if (window.navigator && window.navigator.platform.indexOf("Mac") >= 0) {
        combo[i] = "option"
      } else {
        combo[i] = "alt"
      }
    }

    if (combo[i] == "Enter" || combo[i] == "return") {
      if (window.navigator && window.navigator.platform.indexOf("Mac") >= 0) {
        combo[i] = "return"
      } else {
        combo[i] = "Enter"
      }
    }

    combo[i] = map[combo[i]] || combo[i]
  }

  return combo.join(" + ")
}

const symbolizeHotkey = (keyCombination) => {
  var sequence = keyCombination.split(/[\s]/)
  for (var i = 0; i < sequence.length; i++) {
    sequence[i] = symbolize(sequence[i])
  }
  return sequence
}

export default symbolizeHotkey
